// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__3GbLA","Success":"Button_Success__1xQma","Danger":"Button_Danger__2j2I9"};